// extracted by mini-css-extract-plugin
export default {"departmentSelector":"DepartmentSelector_departmentSelector__GDYqJ","selected":"DepartmentSelector_selected__8zte1","slim":"DepartmentSelector_slim__CdL0m"};